export default "__VITE_ASSET__e2834c1d__$_?nuxt_component=async__"